/**
 * Delvia: yatay Swiper carousel'lerinde trackpad/fare yatay tekerlek desteği.
 *
 * Sorun (Patron 2026-07-09): iPad Magic Keyboard trackpad'i ile iki parmakla yana
 * kaydırınca carousel kaymıyordu; sadece dokunmatik ekrandan parmakla drag çalışıyordu.
 * Sleek teması carousel'leri transform-tabanlı Swiper (overflow:hidden) — Swiper'ın
 * mousewheel modülü bundle'da var ama kapalı, bu yüzden `wheel` olayları yutuluyordu.
 *
 * Çözüm: yatay-baskın wheel (deltaX > deltaY) olayını serbest kaydırmaya (setTranslate ile
 * parmak-takibi) çevir, kullanıcı durunca en yakın slayda snap et (slideToClosest). Dikey
 * tekerlek dokunulmadan geçer → sayfa scroll'u bozulmaz. Kenarda preventDefault yapılmaz →
 * carousel bitince sayfa/parent devralır (rubber-band takılması yok).
 *
 * Hero fade slideshow (`.slideshow-wrapper` / effect:fade) hariç tutulur — orada serbest
 * kaydırma görünümü bozardı. Swiper'lar geç init olabildiği için birkaç kez retry edilir.
 */
(function () {
  function enhance(sw) {
    if (!sw || sw.__delviaWheel) return;
    if (sw.params.effect === 'fade') return;
    if (sw.el && sw.el.classList.contains('slideshow-wrapper')) return;
    if (sw.params.direction !== 'horizontal') return;
    sw.__delviaWheel = true;

    var el = sw.el;
    var idle = null;

    el.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
      if (sw.isLocked) return;

      var min = sw.maxTranslate();
      var max = sw.minTranslate();
      var cur = sw.getTranslate();
      var next = cur - e.deltaX;

      if ((next > max && e.deltaX < 0) || (next < min && e.deltaX > 0)) return;

      e.preventDefault();
      next = Math.max(min, Math.min(max, next));
      sw.setTransition(0);
      sw.setTranslate(next);
      sw.updateProgress(next);
      sw.updateActiveIndex();

      clearTimeout(idle);
      idle = setTimeout(function () { sw.slideToClosest(200); }, 120);
    }, { passive: false });
  }

  function run() {
    document.querySelectorAll('.swiper').forEach(function (el) {
      if (el.swiper) enhance(el.swiper);
    });
  }

  if (document.readyState === 'complete') run();
  else window.addEventListener('load', run);

  var tries = 0;
  var iv = setInterval(function () {
    run();
    if (++tries >= 6) clearInterval(iv);
  }, 700);
})();
